import { TextInput, maxLength, minLength, required } from "react-admin";

const AdmissionMarkerInput = ({ readOnly = false }) => {
  return (
    <TextInput
      readOnly={readOnly}
      source="admissionNumberMarker"
      label="Вх. номер"
      validate={[required(), minLength(1), maxLength(5)]}
      fullWidth={false}
    />
  );
};

export default AdmissionMarkerInput;
